import { computed, ref } from 'vue'

const messages = {
  en: {
    'common.back': 'Back',
    'common.retry': 'Try again',
    'common.close': 'Close',
    'auth.welcomeBack': 'Welcome back',
    'auth.continueAs': 'Continue as {name}',
    'auth.continueStore': 'Use your Lazygrid account to continue with {store}.',
    'auth.continue': 'Continue',
    'auth.otherAccount': 'Use another account',
    'auth.secureAccount': 'Secure customer account',
    'auth.signIn': 'Sign in',
    'auth.signInLede': 'Access your orders, rewards and details for {store}.',
    'auth.or': 'or',
    'auth.identifier': 'Email or mobile number',
    'auth.mobile': 'Mobile number',
    'auth.email': 'Email address',
    'auth.password': 'Password',
    'auth.trustDevice': 'Trust this device',
    'auth.forgotPassword': 'Forgot password?',
    'auth.recoveryAlternatives': 'No code? If you did not finish signing up, create an account or sign in with Google. Contact your store for help with existing rewards.',
    'auth.new': 'New to Lazygrid?',
    'auth.createAccount': 'Create an account',
    'auth.terms': 'By continuing, you agree to Lazygrid’s Terms and Privacy Policy.',
    'auth.create': 'Create account',
    'auth.recovery': 'Account recovery',
    'auth.startIdentity': 'Start with email or mobile',
    'auth.continueMobile': 'Continue with mobile',
    'auth.continueEmail': 'Continue with email',
    'auth.continueGoogle': 'Continue with Google',
    'auth.passwordSecondary': 'Already have an account? Sign in with password',
    'auth.termsPrefix': 'By continuing, you agree to Lazygrid’s',
    'auth.termsLink': 'Terms',
    'auth.and': 'and',
    'auth.privacyLink': 'Privacy Policy',
    'auth.resetPassword': 'Reset your password',
    'auth.sendCodeLede': 'We’ll send a one-time code to verify it belongs to you.',
    'auth.sendCode': 'Send verification code',
    'auth.verification': 'Verification',
    'auth.enterCode': 'Enter your code',
    'auth.codeSent': 'We sent a six-digit code to {destination}.',
    'auth.codeLabel': 'Verification code',
    'auth.verify': 'Verify',
    'auth.resendIn': 'Resend in {seconds}s',
    'auth.resend': 'Send another code',
    'auth.almostThere': 'Almost there',
    'auth.yourName': 'Tell us your name',
    'auth.profileLede': 'This is your global Lazygrid profile. Each store still keeps its own membership and preferences.',
    'auth.firstName': 'First name',
    'auth.lastName': 'Last name (optional)',
    'auth.secure': 'Secure your account',
    'auth.newPassword': 'Choose a new password',
    'auth.createPassword': 'Create your password',
    'auth.passwordLede': 'You’ll use this password with any verified email or mobile number on your account.',
    'auth.confirmPassword': 'Confirm password',
    'auth.saveContinue': 'Save and continue',
    'auth.unsupportedTitle': 'Update required',
    'auth.unsupported': 'This account needs an authentication step this page does not support. Please try another method.',
    'validation.identifier': 'Enter your email or mobile number',
    'validation.email': 'Enter a valid email address',
    'validation.password': 'Use at least 8 characters',
    'validation.passwordMatch': 'Passwords do not match',
    'validation.code': 'Enter the six-digit code',
    'validation.required': 'This field is required',
    'error.restore': 'We couldn’t restore your account. Please try again.',
    'error.credentials': 'The email, mobile number or password is incorrect.',
    'error.sendCode': 'We couldn’t send a verification code. Please try again.',
    'error.code': 'That code is incorrect or has expired.',
    'error.profile': 'We couldn’t save your profile.',
    'error.password': 'We couldn’t save your password.',
    'error.google': 'Google sign-in could not be completed.',
    'error.googleStart': 'Google sign-in could not be started. Please try again.',
    'error.returnStore': 'We couldn’t return you to the store. Please try again.',
    'join.loading': 'Loading your invitation…',
    'join.loadingHelp': 'Checking this secure link.',
    'join.eyebrow': 'Store membership',
    'join.title': 'Join {store}',
    'join.effect': 'Create or connect your membership at this store.',
    'join.authPrompt': 'Choose how you’d like to continue. Every method returns here for your approval.',
    'join.consentTitle': 'Join {store}?',
    'join.consentBody': 'Create or connect your membership at this store. This does not subscribe you to messages.',
    'join.confirm': 'Confirm and join',
    'join.notNow': 'Not now',
    'join.authorizing': 'Joining…',
    'join.successTitle': 'You’ve joined {store}.',
    'join.successBody': 'The POS will update automatically.',
    'join.alreadyTitle': 'You’re already a member of {store}.',
    'join.deferredTitle': 'You can finish later.',
    'join.deferredBody': 'Open this invitation again before {time} to continue.',
    'join.expiredTitle': 'This invitation has expired.',
    'join.expiredBody': 'Ask the store for a new QR code or invitation.',
    'join.cancelledTitle': 'This invitation is no longer available.',
    'join.conflictTitle': 'Verification could not be completed securely.',
    'join.conflictBody': 'Start again or contact the store for help.',
    'join.revokedTitle': 'This membership is no longer available.',
    'join.unavailableTitle': 'This invitation is unavailable.',
    'join.unavailableBody': 'Check the link or ask the store for a new invitation.',
    'join.networkTitle': 'We couldn’t load this invitation.',
    'join.networkBody': 'Check your connection and try again.',
    'join.rateLimited': 'Too many attempts. Try again in {seconds} seconds.',
    'join.sessionExpired': 'Your sign-in expired. Please sign in again before joining.',
    'join.inviteProof': 'This secure invitation verifies the email or mobile channel it was sent to. Review the store and approve below.',
    'join.logoAlt': '{store} logo',
    'counter.successTitle': 'You’ve joined {store}.',
    'counter.successBody': 'Your membership is ready.',
    'counter.alreadyTitle': 'You’re already a member of {store}.',
    'counter.notJoinedTitle': 'You haven’t joined this store.',
    'counter.notJoinedBody': 'Scan the QR whenever you’re ready.',
    'counter.expiredTitle': 'Your secure session expired',
    'counter.expiredBody': 'Continue to start a fresh secure session for this store.',
    'counter.unavailableTitle': 'This counter QR is no longer active.',
    'counter.unavailableBody': 'Ask the store for the current QR.',
    'counter.accountUnavailableTitle': 'Your account is unavailable.',
    'counter.accountUnavailableBody': 'This account cannot join a store membership.',
    'counter.verifiedRequired': 'Verify your email, mobile number, or Google account before joining.'
  },
  'zh-CN': {
    'common.back': '返回', 'common.retry': '重试', 'common.close': '关闭',
    'auth.welcomeBack': '欢迎回来', 'auth.continueAs': '以 {name} 继续', 'auth.continueStore': '使用你的 Lazygrid 账户继续加入 {store}。', 'auth.continue': '继续', 'auth.otherAccount': '使用其他账户',
    'auth.secureAccount': '安全顾客账户', 'auth.signIn': '登录', 'auth.signInLede': '查看你在 {store} 的订单、奖励与资料。', 'auth.or': '或', 'auth.identifier': '邮箱或手机号', 'auth.mobile': '手机号', 'auth.email': '邮箱地址', 'auth.password': '密码', 'auth.trustDevice': '信任此设备', 'auth.forgotPassword': '忘记密码？', 'auth.recoveryAlternatives': '没有收到验证码？如果之前未完成注册，可以创建账户或使用 Google 登录。已有奖励请联系店铺协助恢复。', 'auth.new': '第一次使用 Lazygrid？', 'auth.createAccount': '创建账户', 'auth.terms': '继续即表示你同意 Lazygrid 的服务条款和隐私政策。',
    'auth.create': '创建账户', 'auth.recovery': '找回账户', 'auth.startIdentity': '使用邮箱或手机号开始', 'auth.continueMobile': '使用手机号继续', 'auth.continueEmail': '使用邮箱继续', 'auth.continueGoogle': '使用 Google 继续', 'auth.passwordSecondary': '已有账户？使用密码登录', 'auth.termsPrefix': '继续即表示你同意 Lazygrid 的', 'auth.termsLink': '服务条款', 'auth.and': '和', 'auth.privacyLink': '隐私政策', 'auth.resetPassword': '重置密码', 'auth.sendCodeLede': '我们会发送一次性验证码以确认该联系方式属于你。', 'auth.sendCode': '发送验证码', 'auth.verification': '验证', 'auth.enterCode': '输入验证码', 'auth.codeSent': '六位验证码已发送至 {destination}。', 'auth.codeLabel': '验证码', 'auth.verify': '验证', 'auth.resendIn': '{seconds} 秒后可重发', 'auth.resend': '重新发送验证码',
    'auth.almostThere': '快完成了', 'auth.yourName': '告诉我们你的姓名', 'auth.profileLede': '这是你的全局 Lazygrid 资料。每家门店仍分别管理会员关系和偏好。', 'auth.firstName': '名字', 'auth.lastName': '姓氏（选填）', 'auth.secure': '保护账户', 'auth.newPassword': '设置新密码', 'auth.createPassword': '创建密码', 'auth.passwordLede': '你可以使用密码和任何已验证的邮箱或手机号登录。', 'auth.confirmPassword': '确认密码', 'auth.saveContinue': '保存并继续', 'auth.unsupportedTitle': '需要更新', 'auth.unsupported': '此账户需要当前页面不支持的验证步骤，请尝试其他方式。',
    'validation.identifier': '请输入邮箱或手机号', 'validation.email': '请输入有效的邮箱地址', 'validation.password': '至少输入 8 个字符', 'validation.passwordMatch': '两次密码不一致', 'validation.code': '请输入六位验证码', 'validation.required': '此项为必填',
    'error.restore': '无法恢复你的账户，请重试。', 'error.credentials': '邮箱、手机号或密码不正确。', 'error.sendCode': '无法发送验证码，请重试。', 'error.code': '验证码错误或已过期。', 'error.profile': '无法保存资料。', 'error.password': '无法保存密码。', 'error.google': '无法完成 Google 登录。', 'error.googleStart': '无法启动 Google 登录，请重试。', 'error.returnStore': '无法返回门店，请重试。',
    'join.loading': '正在加载邀请…', 'join.loadingHelp': '正在检查安全链接。', 'join.eyebrow': '门店会员', 'join.title': '加入 {store}', 'join.effect': '创建或连接你在这家门店的会员关系。', 'join.authPrompt': '选择一种继续方式。无论选择哪一种，最后都需要由你确认。', 'join.consentTitle': '加入 {store}？', 'join.consentBody': '创建或连接你在这家门店的会员关系。这不会订阅任何消息。', 'join.confirm': '确认并加入', 'join.notNow': '暂不加入', 'join.authorizing': '正在加入…', 'join.successTitle': '你已加入 {store}。', 'join.successBody': 'POS 会自动更新。', 'join.alreadyTitle': '你已经是 {store} 的会员。', 'join.deferredTitle': '你可以稍后完成。', 'join.deferredBody': '请在 {time} 前重新打开此邀请继续。', 'join.expiredTitle': '此邀请已过期。', 'join.expiredBody': '请向门店索取新的二维码或邀请。', 'join.cancelledTitle': '此邀请已失效。', 'join.conflictTitle': '无法安全完成验证。', 'join.conflictBody': '请重新开始或联系门店获取帮助。', 'join.revokedTitle': '此会员关系已不可用。', 'join.unavailableTitle': '此邀请不可用。', 'join.unavailableBody': '请检查链接，或向门店索取新邀请。', 'join.networkTitle': '无法加载此邀请。', 'join.networkBody': '请检查网络连接后重试。', 'join.rateLimited': '尝试次数过多，请在 {seconds} 秒后重试。', 'join.sessionExpired': '登录已过期，请重新登录后再加入。', 'join.inviteProof': '此安全邀请验证了接收邀请的邮箱或手机号。请核对门店并在下方确认。', 'join.logoAlt': '{store} 标志',
    'counter.successTitle': '你已加入 {store}。', 'counter.successBody': '你的会员资格已就绪。', 'counter.alreadyTitle': '你已经是 {store} 的会员。', 'counter.notJoinedTitle': '你尚未加入这家门店。', 'counter.notJoinedBody': '准备好后请再次扫描二维码。', 'counter.expiredTitle': '安全会话已过期', 'counter.expiredBody': '点击继续，为这家门店启动新的安全会话。', 'counter.unavailableTitle': '此柜台二维码已失效。', 'counter.unavailableBody': '请向门店索取当前二维码。', 'counter.accountUnavailableTitle': '你的账户不可用。', 'counter.accountUnavailableBody': '此账户无法加入门店会员。', 'counter.verifiedRequired': '请先验证邮箱、手机号或 Google 账户，再加入会员。'
  }
}
messages['zh-TW'] = { ...messages['zh-CN'] }

function detectLocale() {
  const languages = navigator.languages?.length ? navigator.languages : [navigator.language]
  for (const language of languages) {
    const normalized = String(language || '').toLowerCase()
    if (normalized.startsWith('zh-tw') || normalized.startsWith('zh-hk') || normalized.includes('hant')) return 'zh-TW'
    if (normalized.startsWith('zh')) return 'zh-CN'
  }
  return 'en'
}

const currentLocale = ref(detectLocale())

export function translate(key, parameters = {}, locale = currentLocale.value) {
  const template = messages[locale]?.[key] ?? messages.en[key] ?? key
  return Object.entries(parameters).reduce(
    (result, [name, value]) => result.replaceAll(`{${name}}`, String(value)),
    template
  )
}

export function useI18n() {
  return {
    locale: computed(() => currentLocale.value),
    setLocale(locale) {
      if (messages[locale]) currentLocale.value = locale
    },
    t: translate
  }
}

export function setDocumentLocale(locale = currentLocale.value) {
  document.documentElement.lang = locale
}
